import * as React from 'react';
import { Button } from 'reactstrap';
import { IArrestBinderList, ICaseBinderList, IChargeBinderList } from 'src/share/types/match';
import ArrestBinderList from './ArrestBinderList';
import CaseBinderList from './CaseBinderList';
import ChargeBinderList from './ChargeBinderList';

export interface IBiometricaBinderListsProps {
  suspectId: string;
  information: {
    arrestBinderList: IArrestBinderList[];
    caseBinderList: ICaseBinderList[];
    chargeBinderList: IChargeBinderList[];
  }
}

export interface IBiometricaDetailState {
  toggleBinderLists: boolean;
}

export class BiometricaBinderLists extends React.Component<IBiometricaBinderListsProps, IBiometricaDetailState> {
  constructor(props: IBiometricaBinderListsProps) {
    super(props);
    this.state = {
      toggleBinderLists: false
    }
  }

  public toggleBinderList = () => {
    this.setState({ toggleBinderLists: !this.state.toggleBinderLists });
  }

  public render() {
    const { information: { arrestBinderList, caseBinderList, chargeBinderList }, suspectId } = this.props;
    const { toggleBinderLists } = this.state;
    return (
      <>
        {
          this.props.information &&
          ((arrestBinderList.length > 0) || (caseBinderList.length > 0) || (chargeBinderList.length > 0)) &&
          <div className="btn-biometrica-binder-list">
            <Button className="btn-blue" onClick={() => this.toggleBinderList()}>
              {toggleBinderLists ? 'Hide' : 'Details'}
            </Button>
          </div>
        }
        {
          toggleBinderLists && this.props.information &&
          <>
            {arrestBinderList && arrestBinderList.length > 0 && <ArrestBinderList arrestBinderList={arrestBinderList} suspectId={suspectId} />}
            {caseBinderList && caseBinderList.length > 0 && <CaseBinderList caseBinderList={caseBinderList} suspectId={suspectId} />}
            {chargeBinderList && chargeBinderList.length > 0 && <ChargeBinderList chargeBinderList={chargeBinderList} suspectId={suspectId} />}
          </>
        }
      </>
    );
  }
}


export default BiometricaBinderLists;
